// extracted by mini-css-extract-plugin
export default {"message":"inline-message_message__y4kvA"};